import { render, staticRenderFns } from "./AreYouShureRemovingDay.vue?vue&type=template&id=48568a9d&scoped=true"
import script from "./AreYouShureRemovingDay.vue?vue&type=script&lang=js"
export * from "./AreYouShureRemovingDay.vue?vue&type=script&lang=js"
import style0 from "./AreYouShureRemovingDay.vue?vue&type=style&index=0&id=48568a9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48568a9d",
  null
  
)

export default component.exports